module.exports = __webpack_public_path__ + "static/media/note-remove.f4515334.svg";